import React,{ useState } from "react";
import TableLogComponents from "../../../components/TableLogComponents";

export default function TableTempaturePage() {
  const [dataSelect, setDataSelect] = useState([])

  const rowTableLogRealtime = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "Firstname",
      dataIndex: "firstname",
      key: "firstname",
    },
    {
      title: "Lastname",
      dataIndex: "lastname",
      key: "lastname",
    },
    {
      title: "Temp",
      dataIndex: "temp",
      key: "temp",
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
    },
    {
      title: "Date / time",
      dataIndex: "datetime",
      key: "datetime",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
    },
    {
      title: "Room",
      dataIndex: "room",
      key: "room",
    },
    {
      title: "Advisor",
      dataIndex: "advisor",
      key: "advisor",
    },
  ];

  const columnsTableLogRealtime = [
    {
      no: "1",
      firstname: "firstname 1",
      lastname: "lastname 1",
      temp: "37.5",
      result: "Positive",
      datetime: "21/08/2565",
      id: "1",
      class: "M5",
      room: "1",
      advisor: "T.Pattarapon",
    },
    {
      no: "2",
      firstname: "firstname 2",
      lastname: "lastname 2",
      temp: "36.5",
      result: "Positive",
      datetime: "21/08/2565",
      id: "2",
      class: "M5",
      room: "1",
      advisor: "T.Pattarapon",
    },
    {
      no: "3",
      firstname: "firstname 3",
      lastname: "lastname 3",
      temp: "36.0",
      result: "Positive",
      datetime: "21/08/2565",
      id: "3",
      class: "M5",
      room: "2",
      advisor: "T.Pattarapon",
    },
    {
      no: "4",
      firstname: "firstname 4",
      lastname: "lastname 4",
      temp: "36.5",
      result: "Positive",
      datetime: "21/08/2565",
      id: "4",
      class: "M5",
      room: "2",
      advisor: "T.Pattarapon",
    },
    {
      no: "5",
      firstname: "firstname 5",
      lastname: "lastname 5",
      temp: "36.7",
      result: "Positive",
      datetime: "21/08/2565",
      id: "5",
      class: "M5",
      room: "2",
      advisor: "T.Pattarapon",
    }
  ];

  const rowSelection = {
    onChange: (selectedRows) => {
      setDataSelect(selectedRows);
    },
  };

  return (
    <div className="box-table-by-nile">
      {/* <button onClick={() => console.log(dataSelect)}>dataSelect</button> */}
      <TableLogComponents
        columns={rowTableLogRealtime}
        dataSource={columnsTableLogRealtime}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
      />
    </div>
  );
}


// import React from "react";
// import CheckItem from "../../../components/CheckItem";
// import TableLogComponents from "../../../components/TableLogComponents";
// export default function TemperatureTable() {
//   return (
//     <div className="box-table-temperature">
//       <TableLogComponents
//         columns={[
//           {
//             title: <CheckItem callBack={(check) => {}} />,
//             dataIndex: "check",
//             key: "check",
//           },
//           {
//             title: "First Name",
//             dataIndex: "firstname",
//             key: "firstname",
//           },
//           {
//             title: "Last Name",
//             dataIndex: "lastname",
//             key: "lastname",
//           },
//           {
//             title: "Temp",
//             dataIndex: "temp",
//             key: "temp",
//           },
//           {
//             title: "Result",
//             dataIndex: "result",
//             key: "result",
//           },
//           {
//             title: "Date/Time",
//             dataIndex: "datetime",
//             key: "dattime",
//           },
//           {
//             title: "ID",
//             dataIndex: "id",
//             key: "id",
//           },
//           {
//             title: "Class",
//             dataIndex: "class",
//             key: "class",
//           },
//           {
//             title: "Room",
//             dataIndex: "room",
//             key: "room",
//           },
//           {
//             title: "Advisor",
//             dataIndex: "advisor",
//             key: "advisor",
//           },
//         ]}
//         dataSource={[
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"1"}
//               </div>
//             ),
//             firstname: "firstname 1",
//             lastname: "lastname 1",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"2"}
//               </div>
//             ),
//             firstname: "firstname 2",
//             lastname: "lastname 2",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"3"}
//               </div>
//             ),
//             firstname: "firstname 3",
//             lastname: "lastname 3",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"4"}
//               </div>
//             ),
//             firstname: "firstname 4",
//             lastname: "lastname 4",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"5"}
//               </div>
//             ),
//             firstname: "firstname 5",
//             lastname: "lastname 5",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"6"}
//               </div>
//             ),
//             firstname: "firstname 6",
//             lastname: "lastname 6",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"7"}
//               </div>
//             ),
//             firstname: "firstname 7",
//             lastname: "lastname 7",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//           {
//             check: (
//               <div className="row-gab1">
//                 <CheckItem callBack={(check) => {}} />
//                 {"8"}
//               </div>
//             ),
//             firstname: "firstname 8",
//             lastname: "lastname 8",
//             temp: "35.5",
//             result: "Negative",
//             datetime: "01/01/65 \n 15:50",
//             id: "ID 1",
//             class: "M5",
//             room: "1",
//             advisor: "T.Pattarapon",
//           },
//         ]}
//       />
//     </div>
//   );
// }
